import CampaignsAdminDetail from './CampaignsAdminDetail';
export default CampaignsAdminDetail;
